export enum ApprovalStatus {
    APPROVED = "APPROVED",
    DENIED = "DENIED",
    PENDING = "PENDING",
    UNKNOWN = "UNKNOWN"
}